import { render, staticRenderFns } from "./DepartmentGroupFinder.vue?vue&type=template&id=7a3083f4&"
import script from "./DepartmentGroupFinder.vue?vue&type=script&lang=ts&"
export * from "./DepartmentGroupFinder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports